export default __webpack_public_path__ + "static/media/scott.0673df91.jpg";